
import { Vue } from "vue-class-component";
import { getNextProductionAsync } from "@/client";
import { Production } from "@/client/models";

export default class Home extends Vue {
  error: string | null = null;
  loading = false;
  nextProduction: Production | null = null;

  async created(): Promise<void> {
    this.$watch(
      () => this.$route.query.date,
      async () => {
        await this.fetchNextProduction();
      },
      { immediate: true }
    );
  }

  async fetchNextProduction(): Promise<void> {
    this.error = null;
    this.loading = true;

    const dateParam = this.$route.query.date;
    const date = Array.isArray(dateParam) ? dateParam[0] : dateParam;

    try {
      this.nextProduction = await getNextProductionAsync(date?.valueOf());
      console.log(this.nextProduction);
      console.log(this.nextProduction.following_production);
    } catch (e) {
      this.error = (e as Error).message;
      this.nextProduction = null;
    }

    this.loading = false;
  }
}
